import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { ExpenditureNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addExpenditure = (state: SyfoAppState, action: PayloadAction<ExpenditureNode>) => {
  if (state.currentVault) {
    // Initialize expenditures array if it doesn't exist
    if (!state.currentVault.data.expenditures) {
      state.currentVault.data.expenditures = [];
    }
    state.currentVault.data.expenditures.push(action.payload);
  }
};

export const updateExpenditure = (state: SyfoAppState, action: PayloadAction<{ id: string; expenditure: Partial<ExpenditureNode> }>) => {
  if (state.currentVault) {
    // Initialize expenditures array if it doesn't exist
    if (!state.currentVault.data.expenditures) {
      state.currentVault.data.expenditures = [];
    }
    updateById(state.currentVault.data.expenditures, action.payload.id, action.payload.expenditure);
  }
};

export const removeExpenditure = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    // Initialize expenditures array if it doesn't exist
    if (!state.currentVault.data.expenditures) {
      state.currentVault.data.expenditures = [];
    }
    state.currentVault.data.expenditures = state.currentVault.data.expenditures.filter(e => e.id !== action.payload);
  }
};